import { useMemo } from 'react';
import { skipToken } from '@reduxjs/toolkit/query';
import { useGetServiceWithOperatorsQuery } from '@/pages/Business/pages/LogisticOperator/services/service-with-operator.service';
import { SelectInputOption } from '@/components/inputs/SelectInput';

interface UseTransitControlServiceWithOperatorsOptionsProps {
  logisticOperatorId?: string | null;
}

const useTransitControlServiceWithOperatorsOptions = ({
  logisticOperatorId,
}: UseTransitControlServiceWithOperatorsOptionsProps = {}) => {
  const id = logisticOperatorId?.trim() ?? '';
  const shouldSkip = !id;

  const { data, isLoading } = useGetServiceWithOperatorsQuery(
    shouldSkip ? skipToken : { logisticOperatorId: id, paginated: { page: 1, pageSize: 500 } }
  );

  const serviceWithOperatorOptions: SelectInputOption[] = useMemo(() => {
    if (!data?.items?.length) return [];
    return data.items
      .map((item) => {
        const label =
          (item as { description?: string }).description ||
          item.commercialService?.commercialName ||
          item.commercialService?.name ||
          item.id;
        return { value: item.id, label };
      })
      .sort((a, b) => a.label.localeCompare(b.label, 'es', { sensitivity: 'base' }));
  }, [data?.items]);

  return {
    serviceWithOperatorOptions,
    isLoading,
    requiresLogisticOperator: !id,
  };
};

export default useTransitControlServiceWithOperatorsOptions;
